import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../lib/cn';

export interface CopyButtonProps {
  value: string;
  className?: string;
  label?: string;
}

/** Иконка-кнопка копирования в буфер обмена с временной галочкой. */
export function CopyButton({ value, className, label }: CopyButtonProps) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    } catch {
      /* clipboard недоступен (insecure context) — игнорируем */
    }
  };

  return (
    <button
      type="button"
      onClick={() => void onCopy()}
      aria-label={label ?? t('common.copy')}
      title={copied ? t('common.copied') : (label ?? t('common.copy'))}
      className={cn(
        'grid h-9 w-9 place-items-center rounded-lg text-fg-muted hover:bg-page hover:text-fg',
        className,
      )}
    >
      {copied ? <Check className="h-4 w-4 text-success" /> : <Copy className="h-4 w-4" />}
    </button>
  );
}
